import 'components/AppLinkInput/index.scss';
import { useContext, useState } from 'react';
import { LINKS } from 'navigation/constants';
import { Lottie } from 'components/Lottie';
import { PERSONAS } from 'common/constants';
import { Row } from 'react-bootstrap';
import { SubmittedContext } from 'SubmittedContext';
import animationData from 'common/images/success-lottie.json';
import { getWindowDimension, getURLSearchParams } from 'common/utils';

const API_URL = 'https://site.yodaa.club/api/submit/whatsapp/';
export const AppLinkInput = ({ type }) => {
  const [number, setNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const { submitted, setSubmitted } = useContext(SubmittedContext);

  const onNumberChange = (event) => {
    const { value } = event.target;
    setNumber(value);
  };

  const onSubmit = async (event) => {
    setLoading(true);
    event.preventDefault();
    try {
      const searchParams = getURLSearchParams();

      await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Request-Headers': '*',
        },
        body: JSON.stringify({
          consent: true,
          phone_number: `91${number}`,
          ...(type === PERSONAS.PARENT && { usertype: 'parent' }),
          ...(!!searchParams && searchParams),
        }),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(false);
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <Row
        noGutters
        className="align-items-center justify-content-center justify-content-lg-start px-5 px-md-0"
      >
        <Lottie width={40} height={40} options={{ animationData }} />
        <p className="success-text ml-2 mt-2 mt-md-0 text-center text-md-left">
          Awesome! We have sent the link.{' '}
          <a target="_blank" rel="noopener" href={LINKS.ONELINK}>
            Download App
          </a>
        </p>
      </Row>
    );
  }

  if (getWindowDimension().width >= 768) {
    return (
      <form onSubmit={onSubmit}>
        <Row noGutters className="justify-content-center justify-content-lg-start">
          <input
            type="tel"
            required
            pattern="^[0-9]+$"
            minLength={10}
            maxLength={10}
            placeholder="Enter Phone Number"
            title="Enter a valid phone number"
            value={number}
            onChange={onNumberChange}
            className="input__number"
          />
          <input
            type="submit"
            value={loading ? 'Please Wait' : 'Get App Link'}
            className="input__submit"
          />
        </Row>
      </form>
    );
  }

  return (
    <form onSubmit={onSubmit}>
      <Row noGutters className="justify-content-center">
        <input
          type="tel"
          required
          pattern="^[0-9]+$"
          minLength={10}
          maxLength={10}
          placeholder="Enter Phone Number"
          title="Enter a valid phone number"
          value={number}
          onChange={onNumberChange}
          className="input__number"
        />
      </Row>
      <Row noGutters className="justify-content-center">
        <input
          type="submit"
          value={loading ? 'Please Wait' : 'Get App Link'}
          className="input__submit"
        />
      </Row>
    </form>
  );
};
